import PageLayout from "src/pages/PageLayout";
import React from "react";

const TermsAndCondition: React.FC = () => {
  return (
    <>
      <PageLayout>
        <div className="container mt-5">
          <h2 className="text-center">Legal Stipulations for Website Usage</h2>

          <div className="mt-4">
            <h4>Usage Permissions</h4>
            <p>
              Your access and use of this digital platform signifies your
              acknowledgement and acceptance of these stipulations. Should you
              disagree with any portion of this agreement, immediate cessation
              of website use is advised. Access to the website, its products,
              and services is exclusively granted to those who have consented to
              these stipulations.
            </p>
          </div>

          <div className="mt-4">
            <h4>Data Handling Procedures</h4>
            <p>
              We urge you to familiarize yourself with our data handling
              procedures, as outlined in our{" "}
              <a
                href="/privacy-policy"
                // target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>
              , prior to continued website engagement. This document provides a
              comprehensive understanding of our user data collection practices.
            </p>
          </div>

          <div className="mt-4">
            <h4>Eligibility Criteria</h4>
            <p>
              To utilize this website, you must have reached the age of 18
              years. By accessing this site, you confirm your legal capacity to
              adhere to this agreement. M/S ANUSHA PUBLICATION disclaims any
              responsibility for issues arising from misrepresented age.
            </p>
          </div>

          <div className="mt-4">
            <h4>Protection of Proprietary Content</h4>
            <p>
              All materials, products, and services presented on this website
              are the exclusive intellectual property of M/S ANUSHA PUBLICATION,
              encompassing copyrights, trade secrets, trademarks, patents, and
              other related rights. Reproduction or redistribution of these
              assets, whether in electronic, digital, or any other format,
              including new trademark registrations, is strictly prohibited.
            </p>
          </div>

          <div className="mt-4">
            <h4>User Registration and Accountability</h4>
            <p>
              Website users may be required to complete a registration process,
              supplying private information. Users are accountable for the
              accuracy and security of this information, as well as all actions
              taken under their account or password. Any suspected security
              breaches should be reported immediately. We reserve the right to
              terminate accounts, modify content, or cancel orders as deemed
              necessary.
            </p>
          </div>

          <div className="mt-4">
            <h4>Governing Legal Framework</h4>
            <p>
              Your utilization of this website implies your agreement that the
              legal statutes of Sitamarhi, Bihar, India, excluding any conflict
              of law principles, will govern these stipulations and any disputes
              arising between M/S ANUSHA PUBLICATION and yourself or its
              business affiliates.
            </p>
          </div>

          <div className="mt-4">
            <h4>Resolution of Conflicts</h4>
            <p>
              Any disputes related to your website access or product purchases
              will be subject to arbitration within the state or Country courts
              of Sitamarhi, Bihar, India, with exclusive jurisdiction and venue
              granted to these courts.
            </p>
          </div>

          <div className="mt-4">
            <h4>Legal Defense and Protection</h4>
            <p>
              You agree to defend and indemnify M/S ANUSHA PUBLICATION and its
              affiliates against any legal claims resulting from your use or
              misuse of our services. We retain the right to appoint our legal
              representation.
            </p>
          </div>

          <div className="mt-4">
            <h4>Limitations on Legal Responsibility</h4>
            <p>
              M/S ANUSHA PUBLICATION shall not be held responsible for any
              damages incurred due to your improper use of this website. We
              reserve the right to revise or alter this agreement at our
              discretion, with notification provided to users via electronic
              communication. This document represents the complete agreement
              between M/S ANUSHA PUBLICATION and the user, superseding all prior
              agreements related to website usage.
            </p>
          </div>
        </div>
      </PageLayout>
    </>
  );
};

export default TermsAndCondition;
